<template>
    <div class="credit-score-bar-graph-container">
        <img src="../assets/bar-empty.svg" class="under" alt="image">
        <img src="../assets/bar-color.svg" :style="barColorStyle " class="over" alt="image">
    </div>
</template>

<script>

    export default {
        name: 'ApplicantCreditProfile',
        computed: {
            barColorStyle() {
                const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

                let percentFromRight = 0;
                if (this.serviceDrive) {
                    percentFromRight = ((clamp(this.creditScore, 0, 500) - 400.0) / 100.0) * 40.0;

                    if (this.creditScore > 500) {
                        percentFromRight += ((clamp(this.creditScore, 0, 600) - 500.0) / 100.0) * 15.0;
                    }
                    if (this.creditScore > 600) {
                        percentFromRight += ((clamp(this.creditScore, 0, 660) - 600.0) / 60.0) * 15.0;
                    }
                    if (this.creditScore > 660) {
                        percentFromRight += ((clamp(this.creditScore, 0, 780) - 660.0) / 120.0) * 15.0;
                    }
                    if (this.creditScore > 780) {
                        percentFromRight += ((clamp(this.creditScore, 0, 850) - 780.0) / 70.0) * 15.0;
                    }
                } else {
                    percentFromRight = ((clamp(this.creditScore, 0, 500) - 400.0) / 100.0) * 40.0;

                    if (this.creditScore > 500) {
                        percentFromRight += ((clamp(this.creditScore, 0, 600) - 500.0) / 100.0) * 15.0;
                    }
                    if (this.creditScore > 600) {
                        percentFromRight += ((clamp(this.creditScore, 0, 660) - 600.0) / 60.0) * 15.0;
                    }
                    if (this.creditScore > 660) {
                        percentFromRight += ((clamp(this.creditScore, 0, 780) - 660.0) / 120.0) * 15.0;
                    }
                    if (this.creditScore > 780) {
                        percentFromRight += ((clamp(this.creditScore, 0, 850) - 780.0) / 70.0) * 15.0;
                    }
                }

                let finalPercentFromRight = 100.0 - (percentFromRight);

                return "-webkit-clip-path: inset(0px " + finalPercentFromRight + "% 0px 0px); clip-path: inset(0px " + finalPercentFromRight + "% 0px 0px);";
            }
        },
        props: {
            creditScore: Number,
            serviceDrive: Boolean
        },
        data: function () {
            return {
            }
        }
    }
</script>

<style scoped>
    .credit-score-bar-graph-container {
        position: relative;
    }

    .under {
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 1;
    }

    .over {
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 2;
    }
</style>
